/* eslint-disable max-classes-per-file */
import { Injectable } from "@angular/core";
import { EventBridgeService } from "../../../common/services/event-bridge.service";

@Injectable({
    providedIn: "root"
})
export class PlaneraEventService extends EventBridgeService {

}

export class PlaneraBridgeEvents {
    static get searchArbetsorderViaStaplar(): string { return "searchArbetsorderViaStaplar"; }
    // Gamla Planera körde på vanliga validationmessages och ngiffade arbetsordern
    // Nya Planera måste ta bort flikar och annat så ett riktigt event behövs för det
    static get arbetsorderProbablyDeleted(): string { return "arbetsorderProbablyDeleted"; }
    // Arbetsordern är borttagen
    static get arbetsorderDeleted(): string { return "arbetsorderDeleted"; }
}
